export const home = {
    text: "home",
    to: {
        name: "home"
    }
};